import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useClientAuth } from '../../contexts/ClientAuthContext';

const BRAND_BLUE = '#4841F0';

const PortalLanding = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { verifyToken, isClientAuthenticated, isLoading, error } = useClientAuth();
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setVerifying(false);
        return;
      }

      const success = await verifyToken(token);
      if (success) {
        navigate('/client-dashboard', { replace: true });
      }
      setVerifying(false);
    };

    verify();
  }, [token, verifyToken, navigate]);

  // Already authenticated, redirect
  useEffect(() => {
    if (isClientAuthenticated && !verifying) {
      navigate('/client-dashboard', { replace: true });
    }
  }, [isClientAuthenticated, verifying, navigate]);

  // Loading state
  if (isLoading || verifying) {
    return (
      <div className="min-h-screen flex flex-col" style={{ background: BRAND_BLUE }}>
        <div className="px-8 py-5">
          <span style={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 800,
            fontSize: '2rem',
            color: '#ffffff',
            letterSpacing: '-0.02em',
          }}>
            Satellite
          </span>
        </div>
        <div className="flex flex-1 flex-col items-center justify-center px-4 pb-16">
          <div style={{
            background: '#ffffff',
            borderRadius: '16px',
            padding: '3rem',
            width: '100%',
            maxWidth: '440px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-6" style={{ borderColor: BRAND_BLUE }}></div>
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 700,
              fontSize: '1.25rem',
              color: '#231f20',
              marginBottom: '0.5rem',
            }}>
              Verifying your access
            </h2>
            <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
              Please wait while we prepare your portal...
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error || !token) {
    return (
      <div className="min-h-screen flex flex-col" style={{ background: BRAND_BLUE }}>
        <div className="px-8 py-5">
          <span style={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 800,
            fontSize: '2rem',
            color: '#ffffff',
            letterSpacing: '-0.02em',
          }}>
            Satellite
          </span>
        </div>
        <div className="flex flex-1 flex-col items-center justify-center px-4 pb-16">
          <div style={{
            background: '#ffffff',
            borderRadius: '16px',
            padding: '3rem',
            width: '100%',
            maxWidth: '440px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: '#fef2f2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
            }}>
              <svg className="w-7 h-7" style={{ color: '#ef4444' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 700,
              fontSize: '1.25rem',
              color: '#231f20',
              marginBottom: '0.5rem',
            }}>
              {!token ? 'Invalid Link' : 'Link Expired'}
            </h2>
            <p style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
              {error || 'This link is not valid. Please contact your Satellite Talent partner for a new access link.'}
            </p>
            <p style={{ color: '#9ca3af', fontSize: '0.75rem' }}>
              Need help? Contact your Satellite Talent partner to receive a fresh link.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default PortalLanding;
